import { Input, Component } from '@angular/core';
import { Router } from '@angular/router';
import { MfsProductService } from '@product/services/mfs-product.service';

@Component({
  selector: 'mojo-master-admin-mfs-widget',
    templateUrl: './master-admin-mfs-widget.component.html'
})
export class MasterAdminMfsWidgetComponent  {

  @Input() clickable: Boolean = true;

  constructor(
    private readonly router: Router) { }

  onImgClick(event) {
    if (this.clickable) {
      this.router.navigateByUrl(MfsProductService.adminDashboard);
    }
  }

}
